var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M15.3174328,5 L17,5 L17,12.3849765 C17,13.6695794 16.855451,14.6896899 16.5663487,15.4453387 C16.2772463,16.2009875 15.7554244,16.8156694 15.0008673,17.2894031 C14.2463102,17.7631367 13.2561495,18 12.0303556,18 C10.8392539,18 9.86499367,17.7936529 9.10754553,17.3809524 C8.3500974,16.9682519 7.80948413,16.3710077 7.48568951,15.5892019 C7.16189488,14.807396 7,13.7393316 7,12.3849765 L7,5 L8.68256722,5 L8.68256722,12.3762575 C8.68256722,13.48648 8.78519701,14.3046028 8.99045967,14.8306506 C9.19572233,15.3566984 9.5484219,15.7621269 10.048569,16.0469484 C10.548716,16.3317698 11.1601583,16.4741784 11.8829141,16.4741784 C13.1202722,16.4741784 14.0020211,16.1922675 14.5281873,15.6284373 C15.0543536,15.0646071 15.3174328,13.980558 15.3174328,12.3762575 L15.3174328,5 Z M6,20 L6,19 L18,19 L18,20 L6,20 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/Underline.65f7f59a.svg";
export { ForwardRef as ReactComponent };